(() => {
  const init = (root = document) => {
    root.querySelectorAll('.mo-nav-refresh').forEach(header => {
      const trigger = header.querySelector('[data-mo-nav-search]');
      const search = header.querySelector('.header__icons .header__search');
      const details = search?.querySelector('details');
      const summary = search?.querySelector('summary');
      if (!trigger || !details || !summary || trigger.dataset.ready) return;
      trigger.dataset.ready = 'true';
      const drawer = header.querySelector('header-drawer');
      summary.addEventListener('click', event => {
        if (drawer?.querySelector('details[open]')) drawer.closeMenuDrawer(event, drawer.querySelector('summary'));
      }, { capture: true });
      let desktopOpener = false;
      trigger.addEventListener('click', event => {
        event.stopPropagation();
        header.querySelectorAll('header-menu details[open]').forEach(menu => menu.querySelector('summary').click());
        desktopOpener = true;
        if (!details.open) summary.click();
        else search.querySelector('input[type="search"]')?.focus();
      });
      details.addEventListener('toggle', () => {
        if (!details.open && desktopOpener) {
          desktopOpener = false;
          if (window.matchMedia('(min-width: 990px)').matches) trigger.focus();
        }
      });
      const hover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
      let pending;
      const closeMenus = except => header.querySelectorAll('header-menu details[open]').forEach(menu => {
        if (menu !== except) menu.querySelector('summary').click();
      });
      header.querySelectorAll('header-menu').forEach(item => {
        const menu = item.querySelector('details');
        const opener = menu?.querySelector('summary');
        if (!menu || !opener) return;
        item.addEventListener('pointerenter', () => {
          if (!hover.matches || details.open) return;
          clearTimeout(pending);
          pending = setTimeout(() => {
            closeMenus(menu);
            if (!menu.open) opener.click();
          }, 140);
        });
        item.addEventListener('pointerleave', () => {
          if (!hover.matches) return;
          clearTimeout(pending);
          pending = setTimeout(() => {
            if (menu.open && !menu.contains(document.activeElement)) opener.click();
          }, 220);
        });
      });
      document.addEventListener('pointerdown', event => {
        if (!header.contains(event.target)) closeMenus();
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

